"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenericEntityClassNames = void 0;
const ControlEntity_1 = require("../model/ControlEntity");
const Entity_1 = require("../model/Entity");
const LevelEntity_1 = require("../model/LevelEntity");
const MobileEntity_1 = require("../model/MobileEntity");
const OperatingEntity_1 = require("../model/OperatingEntity");
const RangeEntity_1 = require("../model/RangeEntity");
const StationaryEntity_1 = require("../model/StationaryEntity");
/**
 * Generic classes to prune (if they are extended from, or by config setting)
 */
exports.GenericEntityClassNames = [
    ControlEntity_1.ControlEntityClassName,
    Entity_1.EntityClassName,
    LevelEntity_1.LevelEntityClassName,
    MobileEntity_1.MobileEntityClassName,
    OperatingEntity_1.OperatingEntityClassName,
    RangeEntity_1.RangeEntityClassName,
    StationaryEntity_1.StationaryEntityClassName,
];
